<template>
    <div
        class="container"
        style="max-width: 1200px">
        <div v-show="newsletterMailingIsLoaded">
            <div class="card mt-2 m-md-4 overflow-auto">
                <NuxtPage />
            </div>
            <div class="p-4 mt-4 d-flex justify-content-center">
                <Impressum />
            </div>
        </div>
        <div v-show="!newsletterMailingIsLoaded">
            <div
                class="d-flex justify-content-center align-items-center"
                style="height: 100vh">
                <font-awesome-icon
                    icon="circle-notch"
                    spin
                    size="8x"
                    class="text-primary" />
            </div>
        </div>
    </div>
</template>
<script>

import mainMailingMixin from "../mixins/mainMailingMixin.js";

export default {
    name: "NewsletterShow",
    mixins: [mainMailingMixin],
}
</script>

<style lang="scss" scoped>

</style>
